/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Agent_Policy_Triggers_DescriptionInputs */



/**
* | output |
* | --- |
* | "The most schedules and events one agent may have. At most {max}." |
*
* @param {Agent_Policy_Triggers_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_triggers_description = /** @type {((inputs: Agent_Policy_Triggers_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Triggers_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Höchstzahl an Auslösern (Zeitpläne und Ereignisse) pro Agent. Höchstens ${i?.max}.`)
	return /** @type {LocalizedString} */ (`The most schedules and events one agent may have. At most ${i?.max}.`)
});